import * as Sentry from "@sentry/sveltekit";

/**
 * Reports a client-side error.
 *
 * Always logs to the console; also forwards to Sentry when it has been
 * initialized (see hooks.client.ts — DSN + deploy-environment gated). Calling
 * Sentry.captureException before/without Sentry.init is a safe no-op, so
 * this doesn't need its own "is Sentry enabled" check.
 */
export function reportClientError(
   error: unknown,
   context?: Record<string, unknown>,
): void {
   console.error("[client-error]", error, context ?? "");
   Sentry.captureException(error, context ? { extra: context } : undefined);
}
